import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDTypography from "../../components/MDTypography";
import MDButton from "../../components/MDButton";
import MDBox from "../../components/MDBox";
import {useDispatch, useSelector} from "react-redux";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import React, {useState} from "react";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {useTranslation} from "react-i18next";
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";
import {addCustomerAddress, customerInfo, deleteCustomerAddress} from "../../actions/customer/customerAction";
import {Logout, onErrorAlert, onSuccessAlert} from "../../actions";
import {ownerSelected} from "../../actions/inventory/inventoryAction";
import LocalStorage from "../../utils/LocalStorage";
import {noop} from "lodash";
import {useNavigate} from "react-router-dom";

const AddressGrid = ({address,setCurrentAddress,setAddresses,setMode,type,data,onInfoSuccess}) => {
    const darkMode = useSelector(state => state?.common?.darkMode,(prev, next) => prev === next)
    const [hoverDelete,setHoverDelete] = useState(false)
    const [isAlertOpen,setIsAlertOpen]  = useState(false)
    const {t} = useTranslation()
    const dispatch = useDispatch()
    const nav = useNavigate()

    const onError = (msg, code) => {
        dispatch(onErrorAlert(msg))
        // setLoading(false)
        // setPageLoading(false)
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }

    return(<Card sx={darkMode?{border:'1px solid white'}:{border:'1px solid #3f50b5'}}>
            <Grid container xs={12} alignItems={'center'} p={1}>
                <Grid item container xs={8} p={1} alignItems={'start'} flexDirection={'column'} justifyContent={'center'}>
                    <Grid item>
                        <MDTypography color={'primary'} variant={'button'} fontWeight={'bold'} >{address?.contact}</MDTypography>
                    </Grid>
                    {/*<Grid item>*/}
                    {/*    <MDTypography variant={'button'} color={'text'} sx={{fontStyle:'italic'}}>{address?.contact}</MDTypography>*/}
                    {/*</Grid>*/}
                    <Grid item>
                        <MDTypography variant={'button'}>{`${address?.address1} ${address?.address2} ${address?.city} ${address?.provinceCode} ${address?.country} ${address?.zipcode}`}</MDTypography>
                    </Grid>
                </Grid>
                <Grid item container xs={4} alignItems={'center'} justifyContent={'flex-end'}>
                    {/*<Grid item xs={12} md={6} textAlign={'center'}>*/}
                    {/*    {address?.isDefault === 'Y'?*/}
                    {/*        <MDTypography color={'primary'}*/}
                    {/*                      variant={'button'}*/}
                    {/*                      fontWeight={'medium'}*/}
                    {/*                      textTransform={'uppercase'}*/}
                    {/*                      sx={{textDecoration:'underline'}}*/}
                    {/*        >*/}
                    {/*            Default*/}
                    {/*        </MDTypography>:*/}
                    {/*        <MDButton*/}
                    {/*            size='small'*/}
                    {/*            variant={'text'}*/}
                    {/*            color={'text'}*/}
                    {/*            sx={type === 'Preview'?{visibility: 'hidden'}:{visibility: 'visible'}}*/}
                    {/*            onClick={()=>{*/}
                    {/*                setAddresses( prev => prev.map(item=>{*/}
                    {/*                    if(item.contactTitle === address.contactTitle){*/}
                    {/*                        return { ...item,isDefault:'Y'}*/}
                    {/*                    } else {*/}
                    {/*                        return { ...item,isDefault:'N'}*/}
                    {/*                    }*/}
                    {/*                }))*/}
                    {/*            }}*/}
                    {/*        >*/}
                    {/*            set as default*/}
                    {/*        </MDButton>*/}
                    {/*    }*/}
                    {/*</Grid>*/}
                    {type !== 'Preview' &&<Grid item xs={12} md={4} textAlign={'center'}
                    >
                        <MDButton color={'primary'}
                                  disabled={!checkPermission(PERMISSION_DICT.OwnerCustomerModifyAddress)}
                                  onClick={()=>{
                                      setCurrentAddress({...address,mode:'Edit'})
                                      setMode('Edit')
                                  }}
                        >
                            {t('Edit')}
                        </MDButton>
                    </Grid>}
                    { type === 'Preview' && <Grid item xs={12} md={4} textAlign={'center'}
                          onClick={()=>{
                              setCurrentAddress({...address,mode:'Preview'})
                              setMode('Preview')
                          }}
                    >
                        <MDButton color={'primary'}>
                            {t('View')}
                        </MDButton>
                    </Grid>}
                    {
                        type !== 'Preview' && checkPermission(PERMISSION_DICT.OwnerCustomerDeleteAddress) &&
                        // <Grid item xs={12} md={2}  textAlign={'center'}>
                            <IconButton
                                // sx={type === 'Preview'?{visibility: 'hidden'}:{visibility: 'visible'}}
                                onMouseEnter={()=> setHoverDelete(true)}
                                onMouseLeave={()=> setHoverDelete(false)}
                                onClick={()=> {

                                    setIsAlertOpen(true)
                                }}
                                aria-label="delete" size="medium">
                                <Icon color={hoverDelete?'error':'text'}>delete_forever</Icon>
                            </IconButton>
                        // </Grid>
                    }
                </Grid>
            </Grid>
        <Dialog
            open={isAlertOpen}
            onClose={() => setIsAlertOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth={'sm'}
        >
            <DialogTitle id="alert-dialog-title">
                <div>{t("Are you sure?")}</div>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {t('Do you really want to delete address:')}
                    <span style={{color: 'red', padding: '10px', fontWeight: 'bold'}}>{address?.contact}</span>
                    ? {t('This process cannot be undone')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <MDButton onClick={() => {
                    setIsAlertOpen(false)
                }}>
                    {t('Disagree')}
                </MDButton>

                <MDButton onClick={() => {
                    if (type === 'Add' || type === 'Copy'){
                        setAddresses(prevArr => prevArr.filter(value=>value.addressId !== address.addressId))
                    }else {
                        let formData = {}
                        formData.ownerId = data.ownerId
                        formData.addressId = address.addressId
                        formData.customerId = data.customerId
                        const apiPost = async () => {
                            await dispatch(deleteCustomerAddress(formData,()=>{
                                dispatch(onSuccessAlert(t("CustomerPage.Delete Address Info successfully")))
                                const axiosPost= async () => {
                                    if(checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
                                        await dispatch(ownerSelected({condition: data?.ownerId, userName: LocalStorage.getItem('username')}, (data)=>setOwnerId(data[0])))
                                    }
                                    let formDataInfo = {}
                                    formDataInfo.ownerId = data.ownerId
                                    formDataInfo.userName = data.ownerName
                                    formDataInfo.customerId = data.customerId
                                    // setLoading(true)
                                    await dispatch(customerInfo(formDataInfo, onInfoSuccess,onError))
                                }
                                axiosPost().then()
                            },onError))
                        }
                        apiPost().then()
                    }
                    setIsAlertOpen(false)
                }}>{t('Agree')}</MDButton>
            </DialogActions>
        </Dialog>

        </Card>)
}

export default AddressGrid